import React from "react";
import { GridColDef } from "../../../Unknown/DataGrid";
import Button from "../../../Unknown/Button";
import Box from "../../../Unknown/Box";
import {
  AppointmentAIReportColumnItemBtnReview,
  AppointmentAIReportRowItem,
} from "../types";

type ColumnValue = {
  canReview: boolean;
  canEdit: boolean;
};

export type ColumnBtnReviewTranslations = {
  btnReview: string;
  btnEdit: string;
};

const getColumnBtnReview = (params: {
  columnItem: AppointmentAIReportColumnItemBtnReview;
  translations: ColumnBtnReviewTranslations;
  onReviewClick?: (id: number) => void;
  onEditClick?: (id: number) => void;
  headerClassName?: string;
}): GridColDef<AppointmentAIReportRowItem, ColumnValue> => {
  const {
    columnItem,
    translations,
    onReviewClick,
    onEditClick,
    headerClassName,
  } = params;
  const { btnReview, btnEdit } = translations;

  return {
    field: columnItem.field,
    headerName: "",
    disableColumnMenu: true,
    minWidth: 120,
    getApplyQuickFilterFn: () => null,
    sortable: false,
    headerClassName,
    valueGetter: (getterParams) => {
      const { row } = getterParams;
      const { status } = row;

      const canReview = status === "requires_review";
      const canEdit = status === "unsent";

      return { canReview, canEdit: canEdit || false };
    },
    renderCell: (renderParams) => {
      const { value, row } = renderParams;

      if (!value) return null;

      const { canReview, canEdit } = value;

      if (canReview && onReviewClick) {
        return (
          <Box display="flex" justifyContent="center" width="100%">
            <Button sx={{ fontSize: 13 }} onClick={() => onReviewClick(row.id)}>
              {btnReview}
            </Button>
          </Box>
        );
      }

      if (canEdit && onEditClick) {
        return (
          <Box display="flex" justifyContent="center" width="100%">
            <Button sx={{ fontSize: 13 }} onClick={() => onEditClick(row.id)}>
              {btnEdit}
            </Button>
          </Box>
        );
      }

      return null;
    },
  };
};

export default getColumnBtnReview;
